export default [
  {
    name: "400_bad_request",
    label: "400 Bad Request",
  },
  {
    name: "401_unauthorized",
    label: "401 Unauthorized",
  },
  {
    name: "404_not_found",
    label: "404 Not Found",
  },
  {
    name: "422_unprocessable_entity",
    label: "422 Unprocessable Entity",
  },
  {
    name: "500_internal_server_error",
    label: "500 Internal Server Error",
  },
  {
    name: "501_not_implemented",
    label: "501 Not Implemented",
  },
  {
    name: "other",
    label: "Other",
  },
];
